const layout = {
    contentMaxWidth: '1122px',
    contentSpacing: '0 16px',
    headerHeight: '108px',
    headerHeightMobile: '88px',
    sectionSpacing: '120px',
    sectionSpacingMobile: '60px',
};

export default layout;
